module.exports = __webpack_public_path__ + "static/media/3.89b062a9.jpeg";